"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixScroll = void 0;
var _styledComponents = require("styled-components");
var _userAgentUtils = require("../../utils/userAgentUtils");
// https://stackoverflow.com/questions/18529381/what-does-webkit-transform-translate3d0-0-0-exactly-do-apply-to-body
var fixScroll = exports.fixScroll = (0, _styledComponents.css)(["", ""], _userAgentUtils.isiOS ? (0, _styledComponents.css)(["transform:translate3d(0,0,0);"]) : null);